export const StickyBanner = () => {
  return null;
};
